/**
 *
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/4/29      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import {message,TreeSelect,Spin} from "antd";
import PropTypes from "prop-types";
import Lang from "@/components/Lang/Lang";
import Locale from "@utils/locale";
import CategorySelectorService from "./CategorySelector.action";
import "./index.less";
// const { TreeNode } = TreeSelect;

class CategoryLimitSelector extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            getCateUrl:props.getCateUrl || '/service/goods/public/category/get/all',
            categoryList:[],
            checkedKeys:[]
        }
    }
    onChange = (value, label, extra) => {
        const { placeholder,maxCount, } = this.props;
        if(value&&maxCount&&value.length>maxCount){
            message.warning(Lang({id: 'ZuiDuoXuanZeWuGe', default: '最多选择五个'}));
            return false
        }else{
            this.props.onChange(value)
        }
    };
    /**
     * 获取二级类目
     */
    loadData = treeNode =>
        new Promise(resolve => {
            const { id } = treeNode.props;
            const { treeData,getCateUrl, } = this.state;
            this.loading(true);
            CategorySelectorService.fetch(getCateUrl,{
                businessPlatform:'essaone',
                lang: Locale.current(),
                buyCategoryId:id
            }).then((res={})=>{
                const resp = res.data;
                this.loading(false);
                if(resp.valid&&resp.success){
                    const categoryList = resp.models||[];
                    categoryList.forEach(item=>{
                        item.pId = id;
                        item.value = item.id;
                        item.key = item.id;
                        item.title = item.name;
                        item.checkable = false;
                        item.isLeaf = true;
                    })
                    treeData.filter(item=>{
                        if(item.id==id){
                            item.children = categoryList
                        }
                    })
                    this.setState({
                        treeData: [...treeData],
                        expandedKey:id
                    });
                }
                resolve();
            }).catch(err=>{
                console.log("err",err)
                resolve();
            });

        })

    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 获取初始
     * */
    onClickPer(item={}){
        const {expandedKey} = this.state
        if(expandedKey==item.id){
            this.setState({
                expandedKey: null
            });
        }else {
            this.loadData({
                props:{
                    id:item.id
                }
            })
        }
    }
    handleRes(resp){
        // 响应结果
        if(resp.valid&&resp.success){
            const treeData = resp.models||[];
            if(treeData.length>0){
                let list = [];
                treeData.forEach(item=>{
                    list.push({
                        id: item.id,
                        value: item.id,
                        key:item.id,
                        title: <span onClick={()=>this.onClickPer(item)}>{item.name}</span>,
                        checkable: false,
                        isLeaf: false,
                        selectable:false,
                        level:item.level
                    })
                })
                this.setState({
                    treeData:list
                })
            }
        }
    }
    genTreeData = (data={}) => {
        CategorySelectorService.fetch(this.state.getCateUrl,{
            businessPlatform:'essaone',
            lang: Locale.current()
        }).then((resp)=>this.handleRes(resp.data)).catch(err=>this.handleRes(err));
    }
    //  onExpand = (newExpandedKeys) => {
    //     console.log("newExpandedKeys",newExpandedKeys)
    //     // setExpandedKeys(newExpandedKeys);
    // };
    componentDidMount(){
        this.genTreeData()
    }

    render(){
        const { placeholder,maxCount, checkedKeys=[],showSearch=false} = this.props;
        const {treeData=[],expandedKey='',loading=false} = this.state;
        console.log("expandedKey",expandedKey)
        return (<Spin spinning={loading}>
            <TreeSelect
                loadData={this.loadData}
                onChange={this.onChange}
                multiple={true}
                showSearch={showSearch}
                treeExpandedKeys={expandedKey?[expandedKey]:[]}
                autoExpandParent={true}
                value={checkedKeys}
                // onExpand={this.onExpand}
                maxCount={maxCount}
                style={{width:'350px',}}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                treeData={treeData}
                placeholder={placeholder||Lang({id: 'QingXuanZeLeiMu', default: '请选择类目'})}
                allowClear>
        </TreeSelect>
        </Spin>)}
}
export default CategoryLimitSelector;
